(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-we-created"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.why-formula-slider', {
  slidesPerView: 1.7,
  loop: true,
  spaceBetween: 32,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
     600: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    900: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 32,
    },
    1201: {
      slidesPerView: 7,
      centeredSlides: false,
      spaceBetween: 36,
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
